import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 0.625rem 0.9375rem;
    border: 0.0625rem solid ${({ theme }) => theme.color.light};
    margin-bottom: 1.25rem;
`;

export const Content = styled.div``;

export const WrapperBox = styled.div`
    width: 100%;
    border: 0.0625rem solid ${({ theme }) => theme.color.extraLight};
    margin-bottom: 0.25rem;

    .accordion-children {
        margin: 0;

        ._wrap-topics {
                
                ._topics {
                        
                    ._topics-list {

                        li {
                            border-bottom: 0.0625rem solid ${({ theme }) => theme.color.light};
                            padding-left: 0.625rem;

                             .faq-accordion {
                                 margin-top: 0;
                                
                                 .MuiAccordionSummary-content {
                                    .MuiTypography-body1 {
                                        font-family: ${({ theme }) => theme.font.nunito};
                                        font-weight: ${({ theme }) => theme.fontWeight.fw700};
                                        color: ${({ theme }) => theme.color.black};
                                        font-size: 0.875rem !important;
                                    }
                                 }

                                 .MuiCollapse-root {

                                    .MuiCollapse-wrapper {

                                        .MuiCollapse-wrapperInner {

                                            div {

                                                .MuiAccordionDetails-root {

                                                    .MuiTypography-root.MuiTypography-body1 {

                                                        div {
                                                            font-family: ${({ theme }) => theme.font.nunito};
                                                            font-weight: ${({ theme }) => theme.fontWeight.fw400};
                                                            color: ${({ theme }) => theme.color.black};
                                                            font-size: 0.875rem !important;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                 }
                             }

                             .faq-accordion.MuiPaper-elevation1 {
                                 box-shadow: none !important;
                             }
                             
                             .faq-accordion.MuiAccordion-root:before {
                                 height: 0 !important;
                             }
                            
                        }

                    }
                     
                }
                
            }
    }
`;

export const ContentBox = styled.div`
    width: 100%;
    /* padding: 0.625rem 0.9375rem; */
    border: 0.0625rem solid ${({ theme }) => theme.color.light};
`;

export const HeadContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 15px;
    background-color: ${({ theme }) => theme.color.light};
`;

export const Head = styled.div`
    margin-bottom: 0.625rem;

    .title {
        text-transform: capitalize;
    }
`;

export const Title = styled.div`
    font-size: 0.875rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${({ theme }) => theme.color.black};
    text-transform: capitalize;
`;

export const WrapIcon = styled.div`
    svg {
        height: 14px;
        width: auto !important;

        path {
            fill: rgba(0, 0, 0, 0.54);
        }
    }
`;
